<template>
	<v-container fluid class="relative">
		<div class="white" id="tool-bar">
			<v-row align="center" justify="start" class="mb-3">
				<v-col lg="2" md="6" sm="6" cols="12" class="d-flex justify-start">
					<slot name="breadcrumbs"></slot>
				</v-col>
				<v-spacer/>
				<v-col lg="2" md="6" sm="6" cols="12" class="d-flex flex-sm-nowrap flex-wrap justify-end align-center">
					<!-- color="addingColor white--text" -->
					<v-btn
						class="rounded-small mb-sm-0 mb-1"
						color="success white--text"
						:width="$vuetify.breakpoint.xsOnly ? '100%' : null"
						@click="createFinancialFileDialog = true"
					>
						<v-icon class="me-1">mdi-plus-circle-outline</v-icon>
						{{$t('FinancialFilesPage.create-financial-file')}}
					</v-btn>
					
					<!-- backup -->
					<!-- color="deletingColor white--text" -->
					<v-btn
						v-if="isAdmin"
						color="alert-color white--text"
						class="rounded-small ms-sm-3"
						:width="$vuetify.breakpoint.xsOnly ? '100%' : null"
						:disabled="backupLoading"
						@click="backupManagementDialog = true; getBackups()"
					>
						<v-icon class="me-1">mdi-database-arrow-down</v-icon>
						{{ $t('FinancialFilesPage.backups-management') }}
					</v-btn>
				</v-col>
			</v-row>
		</div>
		<v-dialog v-model="backupManagementDialog" max-width="550" content-class="rounded-lg">
			<v-card>
				<v-card-title>
					{{ $t('FinancialFilesPage.backups-management') }}
				</v-card-title>
				<v-card-text class="pt-2">
					<!-- <v-row class="pb-2">
						<v-spacer></v-spacer>
						<v-col class="pt-0" cols="auto">
							<v-btn
								color="success white--text"
								class="rounded-small ms-sm-3"
								@click="createBackup()"
							>
								<v-icon class="me-1">mdi-plus</v-icon>
								إنشاء نسخة احتياطية
							</v-btn>
						</v-col>
					</v-row> -->
					<bee-handy-table
						:headers="backupHeaders"
						:items="backupItems"
						:loading="backupLoading"
						pagination-on-scroll
						height="300px"
						shown-rows-text=""
						fixed-header
						elevation="1"
						zebra
					>
						<template v-slot:item.actions="{item}">
							<v-btn
								icon
								:loading="downloadLoading && fileName === item.name"
								@click="downloadBackup(item.name)"							
							>
								<v-icon
								color="primary"
								>
									mdi-cloud-download-outline
								</v-icon>
							</v-btn>

						</template>
						<template v-slot:footer="{}">
							<v-row class="justify-center flex-column align-center">
								<v-col cols="auto" class="pb-0 px-4">
									<v-btn
										depressed
										plain
										color="transparent"
										class="rounded-small ms-sm-3 success--text"
										:loading="createBackupLoading"
										:disabled="backupLoading"
										@click="createBackup()"
									>
										<v-icon class="me-1">mdi-plus</v-icon>
										{{ $t('FinancialFilesPage.create-backup') }}
									</v-btn>
								</v-col>
								<v-col cols="11" class="py-1 px-0">
								<v-divider></v-divider>
								</v-col>
								<v-col cols="auto" class="pb-1 pt-0 px-4">
									<v-btn
										depressed
										plain
										color="transparent"
										:loading="cleaningLoading"
										:disabled="backupLoading"
										class="rounded-small ms-sm-3 red--text"
										@click="cleanBackups()"
									>
										<v-icon class="me-1">mdi-delete</v-icon>
									{{ $t('FinancialFilesPage.delete-old-backups') }}
									</v-btn>
									<v-menu offset-y max-width="250" open-on-hover>
										<template v-slot:activator="{ on, attrs }">
											<i
												v-bind="attrs"
												v-on="on"
												class="fas fa-info-circle mx-2 primary--text"
											/>
										</template>
										<div class="pa-2 fw-bold text-subtitle-2" :style="'background: rgba(255,255,255,0.8)'">
											{{$t('FinancialFilesPage.old-backups-delete-alert')}}
										</div>
									</v-menu>
								</v-col>
							</v-row>
						</template>
					</bee-handy-table>
				</v-card-text>
				<v-card-actions>
					<v-btn text color="red" @click="backupManagementDialog = false">{{$t('FinancialFilesPage.close')}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- change financial file dialog -->
		<bee-dialog
			v-model="changeFinancialFileDialog"
			max-width="400"
			:title="$t('FinancialFilesPage.browse-content') + ' ' + financialFile.companyName"
			:confirm-btn-content="$t('FinancialFilesPage.confirm')"
			@click:confirm="changeFinancialFile()"
			@click:close="changeFinancialFileDialog = false"
		>
			{{
				$t('FinancialFilesPage.do-you-want-to-change-the-current-financial-file')
				+ ` (${currentFinancialFile.name})!`
			}}
		</bee-dialog>

		<!-- financial file data -->
		<bee-dialog
			v-model="editFinancialFileDialog"
			:title="$t('FinancialFilesPage.edit-financial-file')"
			:confirm-btn-content="$t('buttons.save')"
			:disable-confirm="!isValidFinancialFileData || permissionsLoading || financialFileLoading"
			:loading-confirm="financialFileLoading"
			:loading="financialFileLoading"
			persistent
			max-width="600"
			@click:confirm="save"
			@click:close="editFinancialFileDialog = false"
		>
			<v-form
				v-model="isValidFinancialFileData"
				ref="financialFileForm"
				:disabled="financialFileLoading"
			>
				<v-row class="ma-0" justify="center">
					<v-col sm="7" cols="12" class="d-flex pt-0 pb-2">
						<v-img
							:src="
								chosenFileLogo 
								? chosenFileLogo
								: financialFile.fileLogo
									? getLogo(financialFile.fileLogo)
									: require('@/assets/placeholder-image.png')
								"
							lazy-src="@/assets/placeholder-image.png"
							contain
							width="38"
							height="38"
						/>

						<!-- upload logo -->
						<!-- @change="onUpload()" -->
						<div class="mx-2">
							<v-file-input
								v-model="financialFile.image"
								accept="image/png"
								:prepend-icon="financialFile.image ? 'mdi-image' : 'mdi-paperclip'"
								outlined
								dense
								hide-input
							></v-file-input>
						</div>

						<!-- company -->
						<v-text-field
							v-model="financialFile.companyName"
							dense
							outlined
							:label="$t('inputs.company-name')"
							:rules="[rules.required]"
						></v-text-field>
					</v-col>
					
					<!-- year name -->
					<v-col sm="5" cols="12" class="pt-0 pb-2">
						<v-text-field
							v-model="financialFile.yearName"
							dense
							outlined
							:label="$t('inputs.fiscal-year')"
							:rules="[rules.required]"
						></v-text-field>
					</v-col>
					
					<!-- start date -->
					<v-col sm="6" cols="12" class="px-0 pt-0 pb-2">
						<bee-date-picker
							v-model="financialFile.startDate"
							:label="$t('inputs.financial-file-start')"
							:rules="[rules.date]"
							:action-name="actions.CREATE"
							context="financial_file"
						></bee-date-picker>
					</v-col>
					
					<!-- end date -->
					<v-col sm="6" cols="12" class="px-0 pt-0 pb-2">
						<bee-date-picker
							v-model="financialFile.endDate"
							:label="$t('inputs.financial-file-end')"
							:rules="[rules.date]"
							context="financial_file"
							:action-name="actions.CREATE"
						></bee-date-picker>
					</v-col>
					
					<!-- default currency id -->
					<!-- :items="configs.currencies" -->
					<v-col sm="6" cols="12" class="pt-0 pb-2">
						<v-autocomplete
							:label="$t('inputs.currency')"
							v-model="financialFile.defaultCurrencyId"
							:disabled="Boolean(financialFile.id)"
							:items="currencies"
							:rules="[rules.required]"
							:item-text="item => `${item.name} - ${item.symbol}`"
							item-value="id"
							dense
							outlined
						></v-autocomplete>
					</v-col>
					
					<!-- default language -->
					<v-col sm="6" cols="12" class="pt-0 pb-2">
						<v-autocomplete
							v-model="financialFile.defaultLanguage"
							:label="$t('inputs.default-language')"
							:items="availableLangs"
							item-value="id"
							item-text="name"
							dense
							outlined
							:rules="[rules.language]"
						></v-autocomplete>
					</v-col>
				</v-row>
			</v-form>
		</bee-dialog>
		<v-dialog
			v-model="createFinancialFileDialog"
			max-width="600px"
			persistent
			content-class="rounded-xl"
		>
			<v-stepper v-model="currentStep">
				<v-stepper-header>
					<v-stepper-step
						:complete="currentStep > 1"
						step="1"
					>
						{{ $t('FinancialFilesPage.create-financial-file') }}
					</v-stepper-step>
			  
					<v-divider></v-divider>
			  
					<v-stepper-step
						:complete="verticalStepper > 2"
						step="2"
					>
						{{ $t('FinancialFilesPage.configure-financial-file') }}
					</v-stepper-step>
				</v-stepper-header>
				<v-stepper-items >
					<v-stepper-content step="1">
						<v-scroll-x-transition>
							<v-form
								v-model="isValidFinancialFileData"
								ref="createFinancialFileForm"
								:disabled="financialFileLoading"
							>
								<v-row class="ma-0 py-1" justify="center">
									<v-col sm="7" cols="12" class="d-flex pt-0 pb-2">
										<v-img
											:src="
												chosenFileLogo 
												? chosenFileLogo
												: financialFile.fileLogo
													? getLogo(financialFile.fileLogo)
													: require('@/assets/placeholder-image.png')
												"
											lazy-src="@/assets/placeholder-image.png"
											contain
											width="38"
											height="38"
										/>
				
										<!-- upload logo -->
										<!-- @change="onUpload()" -->
										<div class="mx-2">
											<v-file-input
												v-model="financialFile.image"
												accept="image/png"
												:prepend-icon="financialFile.image ? 'mdi-image' : 'mdi-paperclip'"
												outlined
												:disabled="createLoading"
												dense
												hide-input
											></v-file-input>
										</div>
				
										<!-- company -->
										<v-text-field
											v-model="financialFile.companyName"
											dense
											outlined
											:label="$t('inputs.company-name')"
											:disabled="createLoading"
											:rules="[rules.required]"
										></v-text-field>
									</v-col>
									
									<!-- year name -->
									<v-col sm="5" cols="12" class="pt-0 pb-2">
										<v-text-field
											v-model="financialFile.yearName"
											dense
											outlined
											:disabled="createLoading"
											:label="$t('inputs.fiscal-year')"
											:rules="[rules.required]"
										></v-text-field>
									</v-col>
									
									<!-- start date -->
									<v-col sm="6" cols="12" class="px-0 pt-0 pb-2">
										<bee-date-picker
											v-model="financialFile.startDate"
											:label="$t('inputs.financial-file-start')"
											:disabled="createLoading"
											:rules="[rules.date]"
											:action-name="actions.CREATE"
											context="financial_file"
										></bee-date-picker>
									</v-col>
									
									<!-- end date -->
									<v-col sm="6" cols="12" class="px-0 pt-0 pb-2">
										<bee-date-picker
											v-model="financialFile.endDate"
											:label="$t('inputs.financial-file-end')"
											:rules="[rules.date]"
											:disabled="createLoading"
											context="financial_file"
											:action-name="actions.CREATE"
										></bee-date-picker>
									</v-col>
									
									<!-- default currency id -->
									<!-- :items="configs.currencies" -->
									<v-col sm="6" cols="12" class="pt-0 pb-2">
										<v-autocomplete
											:label="$t('inputs.currency')"
											v-model="financialFile.defaultCurrencyId"
											:disabled="Boolean(financialFile.id) || createLoading"
											:items="currencies"
											:rules="[rules.required]"
											:item-text="item => `${item.name} - ${item.symbol}`"
											item-value="id"
											dense
											outlined
										></v-autocomplete>
									</v-col>
									
									<!-- default language -->
									<v-col sm="6" cols="12" class="pt-0 pb-2">
										<v-autocomplete
											v-model="financialFile.defaultLanguage"
											:label="$t('inputs.default-language')"
											:disabled="createLoading"
											:items="availableLangs"
											item-value="id"
											item-text="name"
											dense
											outlined
											:rules="[rules.language]"
										></v-autocomplete>
									</v-col>
									<v-col cols="12" class="py-1"> 
										<v-btn text color="success" :loading="createLoading" @click="save()" >

											{{ 
												$t('buttons.create') 
											}}
										</v-btn>
										<v-btn text color="red" :disabled="createLoading" @click="createFinancialFileDialog = false" >
											{{ $t('buttons.cancel') }}
										</v-btn>
									</v-col>
								</v-row>
							</v-form>
						</v-scroll-x-transition>
					</v-stepper-content>
					<v-stepper-content step="1.5">
						<v-row>
							<v-col cols="12" class="pb-1">
								<v-list-item >
									<v-list-item-content class="pb-1">
										<v-list-item-title class="green--text font-weight-bold d-flex align-center">	
											{{ $t('FinancialFilesPage.financial-file-created-successfully') }}
											<bee-check-icon class="ms-1" size="26px"></bee-check-icon>
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item >
									<v-list-item-content class="pb-4">
										<v-list-item-title class="text-subtitle-2 mb-1">
											{{ $t('FinancialFilesPage.configure-your-financial-file') }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-col>
							<v-col cols="12">
								<v-btn text color="success" @click="currentStep+=0.5" >
									{{ 
										$t('buttons.start') 
									}}
								</v-btn>
								<v-btn text color="red" @click="verticalStepper = 1; currentStep = 1;">
									{{ $t("buttons.close") }}
								</v-btn>
								<!-- <v-btn text color="red" @click="createFinancialFileDialog = false" >
									{{ $t('buttons.cancel') }}
								</v-btn> -->
							</v-col>
						</v-row>
					</v-stepper-content>
					<v-stepper-content step="2" class="pt-3">
						<v-row class="ma-0">

							<v-col cols="12" class="pt-0 pb-2">
									<v-stepper
										v-model="verticalStepper"
										class="pb-3"
										vertical
										flat

									>
										<v-stepper-step step="1" :editable="!configureLoading" :complete="verticalStepper > 1" class="pt-4">
											<span >
												{{ $t('FinancialFilesPage.create-default-warehouse') }}
											</span>
											<i class="fas fa-warehouse mx-1"></i>
											
										</v-stepper-step>
										<v-stepper-content step="1" class="pt-1">
											<v-text-field
												v-model="financialFileConfigurationData.default_warehouse_name"
												class="pb-0 pt-1 mx-2"
												outlined
												dense
												hide-details
												:label="$t('FinancialFilesPage.default-warehouse')"
											>
											</v-text-field>
										</v-stepper-content>
										<v-stepper-step step="2" :editable="!configureLoading" :complete="verticalStepper > 2" class="pt-4">
											<span class="">
												{{ $t('FinancialFilesPage.create-accounting-tree') }}
											</span>
											<i class="fas fa-user  mx-1"></i>
										</v-stepper-step>
										<v-stepper-content step="2" class="pt-0" >
											<v-checkbox
												v-model="financialFileConfigurationData.create_default_accounts_tree"
												class="mx-2 mb-1"
												dense
												hide-details
												:label="$t('FinancialFilesPage.do-you-want-to-create-a-default-accounting-tree')"
											/>
											<v-scroll-x-reverse-transition>
												<!-- <v-checkbox
													v-if="financialFileConfigurationData.create_default_accounts_tree"
													v-model="financialFileConfigurationData.change_default_account_name"
													class="mx-2 mb-2"
													dense
													hide-details
													label="هل تريد تغيير اسم حساب الصندوق الافتراضي؟"
												/> -->

											</v-scroll-x-reverse-transition>

											<v-expand-transition>
												<div v-if="financialFileConfigurationData.create_default_accounts_tree" >
													<v-treeview
														
														:style="accountsTree.length?'height:40vh;overflowY:auto':'overflowY:auto'"
														:items="accountsTree"
														item-text=""
														transition
														color="primary"
														dense
														on-icon="mdi-plus"
														open-on-click
													>
														<template v-slot:prepend="{item}">
															<p :id="'material-'+ item.id" class="ma-0 " :class="{'deletingColor--text':item.type === 1}">
																{{item.accounting_no + '-' + item.name}}
															</p>
														</template>
													</v-treeview>
													<!-- <span
														class="greyDarken2--text text-subtitle-2"
													>
														يرجى تعيين اسم ل حساب الصندوق الافتراضي
													</span>
													<v-text-field
														v-model="financialFileConfigurationData.default_account_name"
														label="حساب الصندوق الافتراضي"
														class="pt-2 pb-4"
														outlined
														dense 
														hide-details
													/> -->

												</div>
											</v-expand-transition>
										</v-stepper-content>
									</v-stepper>
							</v-col>
							<v-col cols="12" class="py-1"> 
								<v-btn v-if="+verticalStepper < 3" text :disabled="+verticalStepper===1 || configureLoading" color="" @click="verticalStepper--" >
									{{ $t('buttons.previous') }}
								</v-btn>
								<v-btn text color="green" :loading="configureLoading" @click="+verticalStepper === 2 ? configureFinancialFile() :verticalStepper++">
									{{ 
										+verticalStepper === 2 ? $t('FinancialFilesPage.configure') : $t('buttons.next')
									}}
								</v-btn>
								<v-btn text color="red" :disabled="configureLoading" @click="verticalStepper = 1; currentStep = 1;createFinancialFileDialog = false">
									{{ $t("buttons.cancel") }}
								</v-btn>
							</v-col>
						</v-row>
					</v-stepper-content>
					<v-stepper-content step="2.5">
						<v-row>
							<v-col cols="12" class="d-flex flex-column pb-0">
								<span  class="green--text mx-5 font-weight-bold d-flex align-center">
									{{ $t("FinancialFilesPage.created-and-configured-successfully") }}
									<bee-check-icon class="ms-1" size="26px"></bee-check-icon>
								</span>
								<div class="d-flex align-center w-100 px-5 pt-2">
									<v-btn plain text class="d-flex align-center" @click="redirectToFinancialFileSettings()">
										{{	$t('FinancialFilesPage.go-to-settings')}}
									</v-btn>
								</div>
							</v-col>
							<v-col cols="12">
								<v-btn text color="red" @click="verticalStepper = 1; currentStep = 1;createFinancialFileDialog = false">
									{{ $t("buttons.close") }}
								</v-btn>
							</v-col>
						</v-row>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-dialog>
		<!-- filter -->
		<v-form @submit.prevent="isFiltered = true; filter();" class="border-container">
			<v-row class="align-center ma-0">
				<!-- name -->
				<v-col md="3" sm="4" cols="12" class="py-sm-0 ps-sm-0">
					<v-text-field
						v-model="filterData.name"
						:label="$t('inputs.name')"
						:disabled="filterLoading"
						dense
						hide-details
						outlined
					></v-text-field>
				</v-col>
				
				<!-- fiscal year -->
				<v-col md="2" sm="3" cols="12" class="py-sm-0 ps-sm-0">
					<v-text-field
						v-model="filterData.fiscalYear"
						:label="$t('inputs.fiscal-year')"
						:disabled="filterLoading"
						dense
						hide-details
						outlined
					></v-text-field>
				</v-col>
				
				<!-- search -->
				<v-col cols="auto" class="py-sm-0 ps-sm-0">
					<v-btn
						type="submit"
						color="info-light-color white--text"
						:disabled="filterLoading"
					>
						<v-icon size="20" class="me-1">mdi-magnify</v-icon>
						{{$t('buttons.search')}}
					</v-btn>

					<v-btn
						v-if="isFiltered"
						icon
						class="ms-2"
						@click="resetFilter"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-col>
			
				<v-spacer/>
			
				<!-- show archived -->
				<v-col cols="auto" class="py-sm-0 ps-sm-0">
					<v-checkbox
						v-model="showArchived"
						:label="$t('inputs.show-archived')"
						hide-details
						class="mt-0"
					/>
				</v-col>
			</v-row>
		</v-form>
		
		<!-- tabs -->
		<v-tabs
			v-model="tab"
			grow
			height="40"
			class="rounded-lg overflow-hidden my-3"
			active-class="primary lighten-1 white--text"
			center-active
			show-arrows
		>
			<v-tab class="blue-grey lighten-5">
				<v-icon size="24" class="me-2">mdi-lock-open-variant-outline</v-icon>
				{{$t('FinancialFilesPage.unlocked')}}
			</v-tab>
			<v-tab class="blue-grey lighten-5">
				<v-icon size="24" class="me-2">mdi-lock-outline</v-icon>
				{{$t('FinancialFilesPage.locked')}}
			</v-tab>
			<v-tab class="blue-grey lighten-5">
				<v-icon size="24" class="me-2">mdi-rotate-3d-variant</v-icon>
				{{$t('FinancialFilesPage.rotated')}}
			</v-tab>
		</v-tabs>
		
		<!-- table -->
		<bee-handy-table
			:headers="headers"
			:items="!loading ? filteredFinancialFiles : []"
			dense
			pagination-on-scroll
			fixed-header
			:height="$vuetify.breakpoint.height - 300"
			:shown-rows-text="$t('components.shown-rows')"
			:loading="loading || filterLoading"
		>
			<!-- company-logo -->
			<template v-slot:item.company-logo="{ item }">
				<v-img
					:src="
						item.company_logo_file
							? getLogo(item.company_logo_file)
							: require('@/assets/placeholder-image.png')
						"
					lazy-src="@/assets/placeholder-image.png"
					width="38"
					height="38"
				/>
			</template>

			<!-- is locked -->
			<template v-slot:item.isLocked="{ item }">
				<div
					:class="
						item.rotation_date
						? 'deletingColor--text'
						: item.is_locked ? 'unactive--text' : 'success--text'
					"
					class="d-flex align-center"
				>
					<v-icon
						left
						dark
						class="mx-1"
						:color="
							item.rotation_date
								? 'deletingColor'
								: (item.is_locked ? 'unactive' : 'success')
						"
					>
						{{
							item.rotation_date
								? 'mdi-sync'
								: (item.is_locked ? 'mdi-lock-outline' : 'mdi-lock-open-variant-outline' )
						}}
					</v-icon>
					<span class="mx-1">
						{{
							item.rotation_date
								? $t('FinancialFilesPage.rotated-to-$',
									{
										financialFile: getFinancialFileById(item.rotated_financial_file_id).company_name
									}
								)
								: item.is_locked
									? $t('FinancialFilesPage.locked')
									: $t('FinancialFilesPage.unlocked')
						}}
					</span>
				</div>
			</template>

			<template v-slot:item.actions="{ item }">
				<!-- preview file -->
				<tooltip :text="$t('tooltip.preview-file')" content-class="me-2">
					<v-btn
						depressed
						height="34"
						width="38"
						min-width="38"
						color="preview-color white--text"
						class="px-1"
						:disabled="currentFinancialFile.id === item.id"
						@click="
							currentFinancialFile.id !== item.id
								? (() => {
									financialFile.id = item.id;
									financialFile.companyName = item.company_name;
									changeFinancialFileDialog = true;
								})()
								: null
						"
					>
						<v-icon>mdi-folder-open</v-icon>
					</v-btn>
				</tooltip>
				
				<!-- edit -->
				<tooltip :text="$t('buttons.edit')" content-class="me-2">
					<v-btn
						depressed
						height="34"
						width="38"
						min-width="38"
						color="edit-color white--text"
						class="px-1"
						@click="editFinancialFileDialog = true; financialFile.id = item.id"
					>
						<v-icon>mdi-pencil</v-icon>
					</v-btn>
				</tooltip>

				<!-- archive -->
				<tooltip
					:text="!item.is_archived ? $t('tooltip.archive') : $t('tooltip.unarchive')"
					content-class="me-2"
				>
					<v-btn
						icon
						:color="!item.is_archived ? 'grey darken-1' : 'info-color'"
						class="px-1 white--text"
						:loading="changeArchiveFileId === item.id"
						:disabled="Boolean(changeArchiveFileId)"
						@click="changeArchiveState(item.id, !item.is_archived)"
					>
						<v-icon>
							{{
								!item.is_archived
									? 'mdi-archive-outline'
									: 'mdi-archive'
							}}
						</v-icon>
					</v-btn>
				</tooltip>
			</template>
		</bee-handy-table>
	</v-container>
</template>
<script>
import rules from "../../../validation";
import { mapState, mapGetters } from "vuex";
import actions from "../../../permissions/actions-names.js"
import ls from '../../../settings/localStorageExtension'
import availableLangs from '../../../settings/constants/availableLangs'
import EventBus from '../../../event-bus'
import { userType } from '../../../helpers/enums'
import { multipleWarehouses } from '../../../configs/global'
export default {
	data: () => ({
		// helpers
		tab: 0,
		showArchived: null,
		
		loading: false,
		financialFileLoading: false,
		permissionsLoading: false,
		backupLoading: false,

		changeFinancialFileDialog: false,

		changeArchiveFileId: null,

		isValidFinancialFileData: false,
		editFinancialFileDialog: false,
		
		isValidPermissions: false,
		permissionsDialog: false,
		
		availableLangs,
		actions,
		...rules,

		// filter
		isFiltered: false,
		filterLoading: false,
		filterData: {
			name: null,
			fiscalYear: null,
		},

		// Data
		userPermissions: [],
		financialFile: {
			id: null,
			companyName: null,
			yearName: null,
			startDate: null,
			endDate: null,
			defaultCurrencyId: null,
			defaultLanguage: 0,
			image: null,
		},
		userType,
		multipleWarehouses,
		backupManagementDialog: false,
		backupItems: [],
		downloadLoading: false,
		fileName: null,
		cleaningLoading: false,
		createBackupLoading: false,
		createFinancialFileDialog: false,
		currentStep: 1,
		financialFileConfigurationData: {
			change_default_warehouse_name: false,
			create_default_accounts_tree: false,
			default_warehouse_name: "مستودع افتراضي",
			change_default_account_name: false
		},
		verticalStepper: 1,
		isCreated: false,
		createLoading: false,
		createdFinancialFileId: null,
		configureLoading: false,
		accountsTree: [],
		chosenFileLogo: null
	}),

	watch: {
		editFinancialFileDialog(val) {
			if (val) {
				const file = this.getFinancialFileById(this.financialFile.id);
				if (file) {
					this.financialFile.companyName = file.company_name;
					this.financialFile.yearName = file.year_name;
					this.financialFile.startDate = file.start_date;
					this.financialFile.endDate = file.end_date;
					this.financialFile.defaultCurrencyId = file.default_currency_id;
					this.financialFile.defaultLanguage = file.default_language;
					this.financialFile.fileLogo = file.company_logo_file;
					this.editFinancialFileDialog = true;
					
					// fetch permissions
					/* this.permissionsLoading = true;
					this.$store.dispatch('financialFiles/fetchPermissions', this.financialFile.id)
						.then(data => {
							if(data.length > 0) {
								const permissionsArr = [];
								data.forEach(item => {
									permissionsArr.push({
										userId: item.user_id,
										permissionType: item.permission_type,
										warehouseIds: item.warehouse_ids ? item.warehouse_ids[0] : null
									})
								});
								this.userPermissions = permissionsArr;
							}
						})
						.finally(() => {
							this.permissionsLoading = false;
						}) */
				} else {
					const currentYear = String(new Date().getFullYear() + 1);
					this.financialFile.startDate = `${currentYear}-01-01`;
					this.financialFile.endDate = `${currentYear}-12-31`;
				}
			}
			else {
				this.$refs.financialFileForm.reset();
				this.financialFile.id = null;
				this.financialFile.startDate = null;
				this.financialFile.endDate = null;
				this.financialFile.fileLogo = null;
				this.chosenFileLogo = null
				this.userPermissions = [];
			}
		},
		createFinancialFileDialog(val) {
			if (val) {
				const currentYear = String(new Date().getFullYear() + 1);
				this.financialFile.startDate = `${currentYear}-01-01`;
				this.financialFile.endDate = `${currentYear}-12-31`;
			}
			else {
				this.$refs.createFinancialFileForm.reset();
				this.financialFile.id = null;
				this.financialFile.startDate = null;
				this.financialFile.endDate = null;
				setTimeout(() => {
					this.currentStep = 1;
					this.verticalStepper =1;
				})
				this.userPermissions = [];
				this.chosenFileLogo = false;
			}
		},
		'financialFile.image'(val) {
			this.chosenFileLogo = URL.createObjectURL(val);
		}
	},

	computed: {
		...mapState({
			configs: state => state.configs.configs,
			currencies: state => state.currencies.currencies,
			financialFiles: state => state.financialFiles.financial_files,
			users: state => state.users.users,
			// warehouses: state => state.warehouses.warehouses,
			// userTypePermission: state => state.permissions.user_type
		}),

		...mapGetters({
			isAdmin: 'auth/isAdmin',
			getFinancialFileById: 'financialFiles/getFinancialFileById',
		}),

		// this part of code will be deleted later because it will be moved to the users page
		// permissions(){
		// 	return [
		// 		{
		// 			permissionType: 2,
		// 			value: this.$t('FinancialFilesPage.permissions.viewer'),
		// 			name: 'Viewer'
		// 		},
		// 		{
		// 			permissionType: 1,
		// 			value: this.$t('FinancialFilesPage.permissions.accountant'),
		// 			name: 'Accountant'
		// 		},
		// 		{
		// 			permissionType: 3,
		// 			value: this.$t('FinancialFilesPage.permissions.warehouse-keeper'),
		// 			name: 'WarehouseKeeper'
		// 		},
		// 		{
		// 			permissionType: 4,
		// 			value: this.$t('FinancialFilesPage.permissions.warehouse-manager'),
		// 			name: 'WarehouseManger'
		// 		}
		// 	]
		// },

		headers() {
			const headers = [
				{
					text: '#',
					name: 'no',
					value: 'id',
					setValueExpr: (value, index) => index + 1,
					sortable: false,
					width: 50
				},
				{
					text: '',
					name: 'company-logo',
					value: 'company_logo_file',
					align: 'center',
					sortable: false,
					width: 50
				},
				{
					text: this.$t('headers.company-name'),
					name: 'company-name',
					value: 'company_name',
					width: 100
				},
				{
					text: this.$t('headers.fiscal-year'),
					name: 'year-name',
					value: 'year_name',
					type: 'string',
					width: '10%'
				},
				{
					text: this.$t('headers.start-date-of-the-file'),
					name: 'start-date',
					value: 'start_date',
					width: 120
				},
				{
					text: this.$t('headers.end-date-of-the-file'),
					name: 'end-date',
					value: 'end_date',
					width: 120
				},
				{
					text: this.$t('headers.currency'),
					name: 'currency',
					value: 'default_currency_id',
					type: 'currencies-autocomplete',
					setValueExpr: (value) => this.getCurrencyById(value)?.symbol,
					width: 40,
				},
				{
					text: this.$t('headers.state'),
					name: 'isLocked',
					value: 'is_locked',
					width: 120,
					sortable: false,
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					sortable: false,
					width: 220,
				}
			];

			for (let i = 0; i < headers.length; i++) {
				headers[i].columnClass = headers[i].columnClass ? headers[i].columnClass + ' px-2' : 'px-2'
			}

			return headers;
		},
		backupHeaders() {
			const headers = [
				{
					text: this.$t('headers.backup-name'),
					name: 'name',
					value: 'name',
					// width: '50%',
					sortable: false,
				},
				{
					text: this.$t('headers.backup-date'),
					name: 'date',
					value: 'date',
					// width: 120,
					sortable: false,
				},
				// {
				// 	text: '',
				// 	name: 'actions',
				// 	width: 50,
				// 	sortable: false
				// }
			]
			return headers
		},

		filteredFinancialFiles() {
			const items = this.financialFiles.filter(c => this.showArchived ? true : !c.is_archived );
			if (this.tab === 1) {
				return items.filter(c => c.is_locked && !c.rotated_financial_file_id);
			} else if (this.tab === 2) {
				return items.filter(c => c.rotated_financial_file_id);
			}
			return items.filter(c => !c.is_locked && !c.rotated_financial_file_id);
		},

		currentFinancialFile(){
			return {
				id: ls.getLocalFinancialFileId(),
				name: this.configs?.financial_file?.company_name
			}
		},
		
		// this part of code has been moved to the users page so it will be deleted later
		// unselectedUsers(){
		// 	return this.users.filter(c => !c.is_admin).map(item => ({
		// 		...item,
		// 		disabled: this.userPermissions.map(c => c.userId).includes(item.id)
		// 	}))
		// },
		//
	},

	methods: {
		filter() {
			this.filterLoading = true;
			return this.$store.dispatch('financialFiles/fetchAll', {
				fiscalYear: this.filterData.fiscalYear,
				companyName: this.filterData.name,
			}).then(() => {
				this.filterLoading = false;	
			})
		},
		
		resetFilter() {
			this.isFiltered = false;
			this.filterData.name = null;
			this.filterData.fiscalYear = null;
			this.filter();
		},

		save() {
			const actionName = this.financialFile.id ? 'update' : 'create';
			if((this.financialFile.id && this.$refs.financialFileForm.validate()) || (this.$refs.createFinancialFileForm.validate())) {
				if(!this.financialFile.id) {
					this.createLoading = true;
				} else {
					this.financialFileLoading = true;
				}
				this.$store.dispatch(`financialFiles/${actionName}`,{
					id: this.financialFile.id,
					company_name: this.financialFile.companyName,
					year_name: this.financialFile.yearName,
					start_date: this.financialFile.startDate,
					end_date: this.financialFile.endDate,
					default_currency_id: this.financialFile.defaultCurrencyId,
					default_language: this.financialFile.defaultLanguage
				})
				.then((data) => {
					this.loading = true;
					/*because the difference between the create and update responses*/
					let id = null
					if(!this.financialFile.id) {
						this.createdFinancialFileId = data;
						id = data;
					} else {
						id = data.id
					}
					const promises = [
					]
					if(this.financialFile.image) {
						promises.push(
							this.$store.dispatch('financialFiles/uploadLogo', {
								id: id,
								file: this.financialFile.image
							})
							.then(()=>{
								if(this.financialFile.id) {
									EventBus.$emit(
										'notification',
										this.$t('FinancialFilesPage.the-logo-is-uploaded-successfully')
									);
								} 
							})
						)
					}
					if(id == this.currentFinancialFile.id) {
						promises.push(this.$store.dispatch('configs/fetchAll'))
					}
					if(this.createdFinancialFileId) {
						promises.push(this.getDefaultAccountsTree(this.createdFinancialFileId))
						promises.push(this.getDefaultWarehouse(this.createdFinancialFileId))
					}
					Promise.all(promises)
					.then(() => {
						this.filter()
						.then(() => {
							if(this.createdFinancialFileId) {
								this.currentStep+=0.5
							}
						})
						.finally(() => {
							this.loading = false;
							this.createLoading = false;
							this.financialFileLoading = false;
							this.editFinancialFileDialog = false;
						});
					}).catch(() => {
						this.createLoading = false;
					})
					.finally(() => {
					})
				}).catch(() => {
					this.financialFileLoading = false;
					this.createLoading = false;
				})
				.finally(() => {

				})
			}
		},

		changeFinancialFile(){
			ls.setLocalFinancialFileId(this.financialFile.id)
			EventBus.$emit('financial-file-id-changed'); 
			
			this.changeFinancialFileDialog = false;
			this.$router.replace({ name: 'home' })
				.then(() => {
					this.$router.go(0);
				})
		},
		redirectToFinancialFileSettings() {
			ls.setLocalFinancialFileId(this.createdFinancialFileId);
			this.$router.replace({name: 'financial-file-settings'}).then(() => {
				this.$router.go(0);
			})
		},
		configureFinancialFile() {
			const promises=[
				this.$store.dispatch('warehouses/editDefaultWarehouse', {
					financialFileId: this.createdFinancialFileId,
					warehouseName: this.financialFileConfigurationData.default_warehouse_name
				})
			]
			if(this.financialFileConfigurationData.create_default_accounts_tree) {
				promises.push(this.$store.dispatch('accounts/createDefaultAccountsTree', this.createdFinancialFileId))
			}
			this.configureLoading = true;
			Promise.all(promises).then(() => {
				this.configureLoading = false;
				this.currentStep+=0.5,this.verticalStepper++ 
			}).finally(() => {
				this.configureLoading = false;

			})
		},
		changeArchiveState(itemId, isArchive) {
			this.changeArchiveFileId = itemId;
			this.$store.dispatch('financialFiles/updateArchive', {
				id: itemId,
				isArchive
			}).then(() => {
				this.filter().finally(() => {
					this.changeArchiveFileId = null;
				})
			})
		},
		
		// this part of code has been moved to the users page so it will be deleted later
		// addUserPermission() {
		// 	this.userPermissions.push({ userId: null, permissionType: null, warehouseIds: null });
		// 	this.$nextTick(() => {
		// 		this.$refs.username[this.userPermissions.length - 1].focus();
		// 	});
		// },
		//

		updatePermissions(financialFileId){
			const permissions = this.userPermissions.length
				? this.userPermissions.map(c => ({
					user_id: c.userId,
					financial_file_id: financialFileId,
					permission_type: this.permissions.find(a => a.permissionType === c.permissionType).name,
					warehouse_ids: c.warehouse_ids === null ? [] : [c.warehouseIds]
				}))
				: []
			return this.$store.dispatch('financialFiles/updatePermissions', {
				id: financialFileId,
				permissions
			})
		},

		createBackup() {
			this.createBackupLoading = true;
			// this.$store.dispatch('configs/createBackup')
			// 	.then((file) => {
			// 		const fileName = `${this.currentFinancialFile.name} ${new Date().toISOString().slice(0, 10)}.bak`;

			// 		const a = document.createElement("a");
			// 		const url = window.URL.createObjectURL(file);
			// 		a.href = url;
			// 		a.download = fileName;
			// 		a.click();
			// 		window.URL.revokeObjectURL(url);
			// 		a.remove();
			// 	})
			// 	.finally(() => {
			// 		this.backupLoading = false;
			// 	})
			this.$store.dispatch('backups/createBackup').then(() => {
				this.getBackups().then(() => {
					this.createBackupLoading = false
				})
			})
		},
		getBackups() {
			this.backupLoading = true;
			return this.$store.dispatch('backups/fetchBackups').then(data =>{
				this.backupItems = data;
				this.backupLoading = false
			})
		},
		downloadBackup(name) {
			this.fileName = name;
			this.downloadLoading = true;
			this.$store.dispatch('backups/downloadBackup', name).then((file) => {
					const blob = new Blob([file]);
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;
					link.download = name; 
					document.body.appendChild(link);
					link.click();
					link.remove();
					window.URL.revokeObjectURL(url);
					EventBus.$emit(
						'notification',
						"تم تحميل النسخة الاحتياطية بنجاح"
					);
					this.downloadLoading = false
			})
		},
		cleanBackups() {
			this.cleaningLoading = true;
			this.$store.dispatch('backups/cleanBackups').then(() => {
				this.cleaningLoading = false
			})
		},
		getLogo(name) {
			return axios.defaults.baseURL.replace('/api/', '') + '/Content/FinancialFiles/Logos/' + name
		},

		getCurrencyById(id) {
			if (this.currentFinancialFile.id) {
				return this.configs.currencies.find(c => c.id === id);
			} else {
				return this.currencies.find(c => c.id === id);
			}
		},
		getDefaultAccountsTree(id) {
			return this.$store.dispatch('accounts/fetchDefaultAccountsTree', id).then(data => {
				this.accountsTree = data;
			})
		},
		getDefaultWarehouse(id) {
			return this.$store.dispatch('warehouses/fetchDefaultWarehouse', id).then(data => {
				this.financialFileConfigurationData.default_warehouse_name = data;
			})

		}
	},
	created() {
		this.loading = true;
		this.createFinancialFileDialog = this.$route.query.createFinancialFile || false
		Promise.all([
			this.filter(),
			!this.users.length ? this.$store.dispatch('users/fetchAll'): null,
			this.currentFinancialFile.id && !Object.keys(this.configs).length
				? this.$store.dispatch('configs/fetchAll')
				: null,
			!this.currentFinancialFile.id || !this.currencies.length 
				? this.$store.dispatch('currencies/fetchAll')
				: null,
			// !this.warehouses.length ? this.$store.dispatch('warehouses/fetchAll') : null
		]).finally(() => {
			this.loading = false;
		})
	}
};
</script>
<style>
</style>
